import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BookingComponent } from '../booking/booking.component';

@Component({
  selector: 'app-confirmation-popup',
  templateUrl: './confirmation-popup.component.html',
  styleUrls: ['./confirmation-popup.component.scss']
})
export class ConfirmationPopupComponent {
  constructor(
    public dialog: MatDialog,private dialogRef: MatDialogRef<BookingComponent>,@Inject(MAT_DIALOG_DATA) public data: any

    
  ) { 

  }

  submit() {
    this.dialogRef.close(true); 
  }

  cancelDialog() {
    this.dialogRef.close(false); 
  }
}
